import React from 'react';
import { Anchor, Text, Title, Skeleton } from '@mantine/core';
import { IconMapPin } from '@tabler/icons-react';
import { useQuery } from '@apollo/client';

import stringifyNumber from '../../utility/stringifyNumber';
import { GET_COMPETITOR_FOR_REQUEST } from '../../apollo/queries/priceChangeRequest';

type Props = {
    requestId: string | null;
};

function RequestCompetitorDetails({ requestId }: Props) {
    const { data, loading } = useQuery(GET_COMPETITOR_FOR_REQUEST, {
        variables: { requestId: requestId! },
        skip: !requestId,
        fetchPolicy: 'cache-and-network',
    });

    const competitor = data?.getCompetitorForRequest;

    if (loading) {
        return (
            <div className="flex flex-col flex-1 mt-10 gap-5">
                <Title order={4}>Competitor Details</Title>
                <div className="flex">
                    <div className="flex flex-1 flex-col gap-3 px-4 pb-3">
                        <Skeleton height={10} width={60} />
                        <Skeleton height={10} width={100} />
                    </div>
                    <div className="flex flex-1 flex-col gap-3 px-4 pb-3">
                        <Skeleton height={10} width={100} />
                        <Skeleton height={10} width={80} />
                    </div>
                    <div className="flex flex-1 flex-col gap-3 px-4 pb-3">
                        <Skeleton height={10} width={50} />
                        <Skeleton height={10} width={120} />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col flex-1 mt-10 gap-5">
            <Title order={4}>Competitor Details</Title>
            <div className="flex">
                <div className="flex flex-1 flex-col gap-3 px-4 pb-3">
                    <Text className="text-xs text-[#7d8fb3] font-bold uppercase">
                        Name
                    </Text>
                    <Text className="text-xs text-[#4D5E80] uppercase">
                        {competitor?.name || 'N/A'}
                    </Text>
                </div>
                <div
                    className="flex flex-1 flex-col gap-3 px-4 pb-3"
                    style={{
                        borderLeft: '2px solid #EDEFF2',
                    }}
                >
                    <Text className="text-xs text-[#7d8fb3] font-bold uppercase">
                        Contact Details
                    </Text>
                    <Anchor
                        className="text-xs text-[#4D5E80] uppercase"
                        href={`tel:${stringifyNumber(competitor?.telNo)}`}
                    >
                        {stringifyNumber(competitor?.telNo)}
                    </Anchor>
                </div>
                <div
                    className="flex flex-1 flex-col gap-3 px-4 pb-3"
                    style={{
                        borderLeft: '2px solid #EDEFF2',
                    }}
                >
                    <Text className="text-xs text-[#7d8fb3] font-bold uppercase">
                        Store
                    </Text>
                    <div className="flex gap-2 items-center">
                        <IconMapPin size={18} />
                        <Text className="text-xs text-[#4D5E80] uppercase">
                            {competitor?.address || 'N/A'}
                        </Text>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RequestCompetitorDetails;
